import {
  ControlledDateInput,
  ControlledInput,
} from "components/Card/ControlledInput";
import { MaskedInput, TextInput, ControlledTextArea } from "components/inputs";
import type {
  Control,
  UseFormGetValues,
  UseFormSetValue,
} from "react-hook-form";
import type { ConstantTypes } from "types/DataTypes";

import type { LienFormValues } from "../../../LienTypes";

type SecondLienRequestSectionProps = {
  control: Control<LienFormValues>;
  getValues: UseFormGetValues<LienFormValues>;
  setValue: UseFormSetValue<LienFormValues>;
  handleFieldChange: (field: string | null, value: unknown) => Promise<void>;
  constants?: ConstantTypes;
};

const SecondLienRequestSection = ({
  control,
  getValues,
  setValue,
  handleFieldChange,
}: SecondLienRequestSectionProps) => {
  const submittedOn = getValues("second_lien_request_submitted_on");
  const shouldDisableFields =
    getValues("initial_lien_request_no_interest_letter_received") ||
    getValues("initial_lien_request_itemization_received");

  return (
    <>
      <h3>Second Lien Request</h3>
      <ControlledDateInput
        control={control}
        name="second_lien_request_submitted_on"
        label="Date Request Made"
        onSave={async (value) => {
          if (!value) {
            setValue("second_lien_request_user_notes", null);
            setValue("second_lien_request_plan_name", null);
            setValue("second_lien_request_plan_address", null);
            setValue("second_lien_request_plan_contact_number", null);
            setValue("second_lien_request_subrogation_agent_name", null);
            setValue("second_lien_request_subrogation_phone", null);
            setValue("second_lien_request_method", null);
            await handleFieldChange(null, {
              second_lien_request_submitted_on: null,
              second_lien_request_user_notes: null,
              second_lien_request_plan_name: null,
              second_lien_request_plan_address: null,
              second_lien_request_plan_contact_number: null,
              second_lien_request_subrogation_agent_name: null,
              second_lien_request_subrogation_phone: null,
              second_lien_request_method: null,
            });
          } else {
            await handleFieldChange("second_lien_request_submitted_on", value);
          }
        }}
        errors={{}}
        readOnly={shouldDisableFields}
      />
      {submittedOn && (
        <>
          <ControlledInput
            control={control}
            name="second_lien_request_plan_name"
            label="Plan Name"
            onSave={(value) =>
              handleFieldChange("second_lien_request_plan_name", value)
            }
            errors={{}}
            componentType={TextInput}
            readOnly={shouldDisableFields}
          />
          <ControlledInput
            control={control}
            name="second_lien_request_plan_address"
            label="Plan Address"
            onSave={(value) =>
              handleFieldChange("second_lien_request_plan_address", value)
            }
            errors={{}}
            componentType={TextInput}
            readOnly={shouldDisableFields}
          />
          <ControlledInput
            control={control}
            name="second_lien_request_plan_contact_number"
            label="Plan Contact Number"
            onSave={(value) =>
              handleFieldChange(
                "second_lien_request_plan_contact_number",
                value,
              )
            }
            errors={{}}
            componentType={MaskedInput}
            mask="phone"
            readOnly={shouldDisableFields}
          />
          <ControlledInput
            control={control}
            name="second_lien_request_subrogation_agent_name"
            label="Subrogation Agent Name"
            onSave={(value) =>
              handleFieldChange(
                "second_lien_request_subrogation_agent_name",
                value,
              )
            }
            errors={{}}
            componentType={TextInput}
            readOnly={shouldDisableFields}
          />
          <ControlledInput
            control={control}
            name="second_lien_request_subrogation_phone"
            label="Subrogation Phone"
            onSave={(value) =>
              handleFieldChange("second_lien_request_subrogation_phone", value)
            }
            errors={{}}
            componentType={MaskedInput}
            mask="phone"
            readOnly={shouldDisableFields}
          />
          <ControlledInput
            control={control}
            name="second_lien_request_method"
            label="Request Method"
            onSave={(value) =>
              handleFieldChange("second_lien_request_method", value)
            }
            errors={{}}
            componentType={TextInput}
            readOnly={shouldDisableFields}
          />
          <div>
            <label>Notes:</label>
            <ControlledTextArea
              control={control}
              name="second_lien_request_user_notes"
              label={null}
              advancedEdit={true}
              maxLength={2000}
              errors={{}}
              onSave={(value) =>
                handleFieldChange("second_lien_request_user_notes", value)
              }
            />
          </div>
        </>
      )}
    </>
  );
};

export default SecondLienRequestSection;
